import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom"
import { Search, Label } from 'semantic-ui-react'


const resultRenderer = ({ path, title }) => {
	console.log(title);
	return (<Link to={path} key={title}> {title} </Link>)
}

resultRenderer.propTypes = {
	name: PropTypes.string,
}

export class SearchPlaces extends Component {

	constructor() {
		super();
		this.state = {
			loading: false,
			value: null,
			results: []
		}
	}
	componentWillMount() {
		this.resetComponent()
	}


	resetComponent = () => this.setState({ isLoading: false, results: [], value: '' })

	handleResultSelect = (e, { result }) => this.props.history.push(result.path)

	handleSearchChange = (e, { value }) => {
		this.setState({ isLoading: true, value })


		setTimeout(() => {
			if (this.state.value.length < 1) return this.resetComponent()

			const re = new RegExp(`${this.state.value}`, 'i');

			let results = this.props.data.filter((d)=>d.name.match(re)).map(d=>{ return {title:d.name, path:d.path}})
			console.log(results);
			this.setState({
				isLoading: false,
				results
			})


		}, 300)


	}

	render() {
		const { isLoading, value, results } = this.state
		return (
			<Search
			loading={isLoading}
			onResultSelect={this.handleResultSelect}
			onSearchChange={this.handleSearchChange}
			results={results}
			resultRenderer={resultRenderer}
			value={value}
			/>
			)
	}
}
export default withRouter(SearchPlaces);



// WEBPACK FOOTER //
// ./src/itemslist/SearchPlaces.js